import * as React from 'react';

import type {
    CustomFieldValueInput,
    EntityAttribute as EntityAttributeFragment,
} from 'nutshell-graphql-types';

import {InlineTextfieldForm} from './inline-textfield-form';

type Props = {
    field: EntityAttributeFragment;
    value: CustomFieldValueInput['string'];
    onChange: (newVal: CustomFieldValueInput) => void;
    onSubmit: () => any;
    onCancel: () => any;
    isDirty: boolean;
    blinkSuccess: boolean;
    label: string;
};

export class GraphQLFieldString extends React.PureComponent<Props> {
    render() {
        const {
            onChange, // eslint-disable-line @typescript-eslint/no-unused-vars
            ...restProps
        } = this.props;

        return <InlineTextfieldForm {...restProps} onChange={this.handleChange} />;
    }

    handleChange = (newVal: string) => {
        this.props.onChange({
            // Our mutations expect null instead of an empty string
            // to clear the value
            string: newVal.length ? newVal : null,
        });
    };
}
